import React from "react";
import { render } from "react-dom";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
// eslint-disable-next-line import/no-extraneous-dependencies
import { ThemeProvider } from "@material-ui/styles";
import "./index.css";
import { AnalyticsUtil } from "@oriola-origo/origo-common-client-lib";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import i18n from "./localization/i18n";
import * as serviceWorker from "./serviceWorker";
import configureStore from "./redux/config/configureStore";
import { OriolaTheme } from "./theme";

// init analytics before redux since the redux-beacon is used for sending events to GTM
AnalyticsUtil.initializeAnalytics();

// redux store
const store = configureStore();

// the app
const renderApp = () =>
  render(
    <Provider store={store}>
      <BrowserRouter>
        <ThemeProvider theme={OriolaTheme}>
          <I18nextProvider i18n={i18n}>
            <App />
          </I18nextProvider>
        </ThemeProvider>
      </BrowserRouter>
    </Provider>,
    document.getElementById("root")
  );

// reload only changed
if (process.env.NODE_ENV !== "production" && module.hot) {
  module.hot.accept("./App", renderApp);
}

renderApp();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
